// Componente copiado de: src/paginas/avaliacao-desempenho/Elogios/Feed/Curtir/index.js
// Adaptado para comentários de ItemValor

import { useState } from 'react';
import { useIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';

import Avatar from 'src/componentes/avatar';
import useAuth from 'src/hooks/useAuth';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import LucideIcon from 'src/componentes/lucide-icon';

export default function CurtirComentarioButton({
  curtidas,
  comentarioId,
  endpoint,
}) {
  const { user } = useAuth();
  const intl = useIntl();
  const [curtido, setCurtido] = useState(
    curtidas?.find((e) => e.id == user?.id)
  );
  const [curtidasLocal, setCurtidasLocal] = useState(curtidas || []);

  const curtir = async () => {
    try {
      await http.post(endpoint, {
        comentarioId: comentarioId,
      });

      if (curtido) {
        setCurtidasLocal(curtidasLocal.filter((c) => c.id !== user.id));
      } else {
        setCurtidasLocal([
          ...curtidasLocal,
          {
            id: user.id,
            nome: user.nome,
            fotoArquivo: user.fotoArquivo,
          },
        ]);
      }

      setCurtido(!curtido);
    } catch (err) {
      errorHandler(err);
    }
  };

  const outrasCurtidas = curtidasLocal?.filter((e) => e.id !== user?.id);
  const totalCurtidas = outrasCurtidas?.length + (curtido ? 1 : 0);

  const quantidadeCurtidasId = `popover-comentario-${comentarioId}`;
  const tooltipHeartId = `tooltip-heart-comentario-${comentarioId}`;

  return (
    <div className="d-flex align-items-center">
      <LucideIcon
        icon={curtido ? 'HeartFilled' : 'Heart'}
        size={20}
        cursor="pointer"
        color={curtido ? 'red' : '#1d7789'}
        colorHover={curtido ? 'red' : '#1d7789'}
        fill={curtido ? 'red' : 'white'}
        onClick={curtir}
        id={tooltipHeartId}
        data-tip
        data-for={tooltipHeartId}
        style={{ cursor: 'pointer' }}
      />
      <ReactTooltip
        id={tooltipHeartId}
        aria-haspopup="true"
        className="max-w-25"
        effect="solid"
        place="bottom"
      >
        {intl.formatMessage({ id: 'curtirComentario' })}
      </ReactTooltip>
      <div className="ml-1 mr-4 cursor-default" id={quantidadeCurtidasId}>
        {`${totalCurtidas} ${intl.formatMessage({
          id: totalCurtidas == 1 ? 'curtida' : 'curtidas',
        })}`}
      </div>
      {(outrasCurtidas?.length > 0 || curtido) && (
        <UncontrolledPopover
          trigger="hover"
          placement="bottom"
          target={quantidadeCurtidasId}
        >
          <PopoverBody>
            <div style={{ overflowY: 'auto', maxHeight: 150 }}>
              {curtido && (
                <div className="mb-1">
                  <Avatar
                    size={24}
                    id={`avatar-${user.id}`}
                    foto={user.fotoArquivo}
                    label={user.nome}
                  />
                </div>
              )}
              {outrasCurtidas?.map((item) => (
                <div className="mb-1" key={item.id}>
                  <Avatar
                    size={24}
                    id={`avatar-${item.id}`}
                    foto={item.fotoArquivo}
                    label={item.nome}
                  />
                </div>
              ))}
            </div>
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </div>
  );
}
